import { SpinnerDotted } from "spinners-react";
import VCard from "vcard-creator";
import fileDownload from "js-file-download";
import { Fragment, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { appDb } from "../config";
import { doc, getDoc } from "firebase/firestore";
import { Image } from "../components/Image";
import { QRNormal } from "react-qrbtf";
import Icon from "./../assets/img/logo.png";
import ReactCardFlip from "react-card-flip";
import Sheet from "react-modal-sheet";
import { Brand } from "./brand";
import { Dialog, Transition } from "@headlessui/react";
import BusinessCardProfile from "../components/company";
import { BoltIcon } from "@heroicons/react/24/outline";
import { browserName, deviceType } from "react-device-detect";
import { createClient } from "@supabase/supabase-js";
import { Other } from "../components/other";
import AndroidInstructions from "../components/AndroidInstructions";
import SaveContactInstructions from "../components/SaveContactInstructions";
import { isAndroid } from "../utils/deviceUtils";
import { SocialIcon } from "react-social-icons";
import { CheckBadgeIcon, ChatBubbleLeftRightIcon, EnvelopeIcon, PhoneIcon, GlobeAltIcon } from "@heroicons/react/24/outline";

// Create a single supabase client for interacting with your database
const supabase = createClient(
  "https://zpzbhljrzxaiaifwdmyj.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpwemJobGpyenhhaWFpZndkbXlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzMjkxNTcsImV4cCI6MjA4ODkwNTE1N30.JtTKK2KThrAhW1N9Av9y9RINdufTQFujJfNC2SPp8Bo"
);

function Card() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [team, setTeam] = useState(null);
  let { id } = useParams();
  const [showBack, setShowBack] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [codeExpanded, setCodeExpanded] = useState(false);
  const [installOpened, setInstallOpened] = useState(false);
  const [confirmSaveOpened, setConfirmSaveOpened] = useState(false);

  const [isFooterVisible, setIsFooterVisible] = useState(true);

  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY.current + 10) {
            setIsFooterVisible(false);
          } else if (currentScrollY < lastScrollY.current - 10) {
            setIsFooterVisible(true);
          }
          lastScrollY.current = currentScrollY > 0 ? currentScrollY : 0;
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (id) {
      getData(id);
      const referrer =
        document.referrer && document.referrer !== window.location.href
          ? document.referrer
          : null;
      saveEvent({
        action_type: "view_profile",
        target: "card_profile",
        referrer,
      });
    }
  }, [id]);

  const getData = async (forId) => {
    setLoading(true);
    
    // First, check the "cards" collection
    const cardDocRef = doc(appDb, "cards", forId);
    await getDoc(cardDocRef)
      .then(async (cardDocSnap) => {
        if (cardDocSnap.exists()) {
          const cardData = cardDocSnap.data();
          
          // Check card type first
          if (cardData.type === "business") {
            // Use the "owner" property to fetch from "public_profiles"
            if (cardData.owner) {
              const profileDocRef = doc(appDb, "public_profiles", cardData.owner);
              await getDoc(profileDocRef)
                .then(async (profileDocSnap) => {
                  if (profileDocSnap.exists()) {
                    const data = profileDocSnap.data();
                    if (data && data.is_private) {
                      save(data);
                    } else {
                      setData(profileDocSnap.data());
                      if (data.team) {
                        await getDoc(data.team).then((doc) => {
                          if (doc.exists()) {
                            setTeam(doc.data());
                          } else {
                          }
                        });
                      }
                    }
                  }
                  setLoading(false);
                })
                .catch((err) => {
                  setLoading(false);
                });
            } else {
              setLoading(false);
            }
          } else if (cardData.type === "review") {
            // Lookup document from "plaques" collection using the owner property
            if (cardData.owner) {
              const plaqueDocRef = doc(appDb, "plaques", cardData.owner);
              await getDoc(plaqueDocRef)
                .then((plaqueDocSnap) => {
                  if (plaqueDocSnap.exists()) {
                    const plaqueData = plaqueDocSnap.data();
                    if (plaqueData.place_id && plaqueData.type === "google") {
                      // Redirect to Google review platform
                      const googleReviewUrl = `https://search.google.com/local/writereview?placeid=${plaqueData.place_id}`;
                      window.location.href = googleReviewUrl;
                    } else {
                      setLoading(false);
                    }
                  } else {
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  setLoading(false);
                });
            } else {
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Helper function to clean address fields
  const cleanAddressField = (address) => {
    if (!address) return '';
    return address
      .replace(/[,\-]/g, ' ') // Replace commas and dashes with spaces
      .replace(/\n/g, ' ') // Replace newlines with spaces
      .replace(/\r/g, ' ') // Replace carriage returns with spaces
      .replace(/\\n/g, ' ') // Replace escaped newlines with spaces
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim(); // Remove leading/trailing spaces
  };

  const save = (userInfo) => {
    saveEvent({ action_type: "save", target: "save_btn" });
    const card = new VCard();
    
    // Parse name into components (lastname, firstname, additional, prefix, suffix)
    const nameParts = userInfo.general.full_names ? userInfo.general.full_names.split(' ') : ['', '', '', '', ''];
    const lastname = nameParts[nameParts.length - 1] || '';
    const firstname = nameParts.slice(0, -1).join(' ') || '';
    const additional = '';
    const prefix = '';
    const suffix = '';
    
    if (team !== null) {
      card.setFormat("vcard");
      card.addName(lastname, firstname, additional, prefix, suffix);
      card.addRole(userInfo.general.job_title);
      card.addJobtitle(userInfo.general.job_title);
      card.addLogoURL(team.brand.logo);
      card.addCompany(team.brand.name);
      
      // Add website URL properly
      if (team.brand.website) {
        card.addURL(team.brand.website, "WORK");
      }
      
      card.addPhotoURL(userInfo.profile);
      card.addPhoneNumber(userInfo.general.phone, "PREF;WORK;VOICE");
      card.addEmail(userInfo.general.email);
      
      // Add address as full text in street field
      if (team.brand.address) {
        const cleanedAddress = cleanAddressField(team.brand.address);
        card.addAddress('', '', cleanedAddress, '', '', '', '');
      }
      
      // Add social links if available (just URL, no platform/handle)
      if (userInfo.links && userInfo.links.social) {
        userInfo.links.social.forEach((socialUrl) => {
          if (socialUrl) {
            // Detect social platform type from URL
            let platform = "WORK";
            if (socialUrl.includes('linkedin.com')) {
              platform = "LinkedIn";
            } else if (socialUrl.includes('twitter.com') || socialUrl.includes('x.com')) {
              platform = "Twitter";
            } else if (socialUrl.includes('facebook.com')) {
              platform = "Facebook";
            } else if (socialUrl.includes('instagram.com')) {
              platform = "Instagram";
            } else if (socialUrl.includes('github.com')) {
              platform = "GitHub";
            } else if (socialUrl.includes('youtube.com')) {
              platform = "YouTube";
            } else if (socialUrl.includes('tiktok.com')) {
              platform = "TikTok";
            }
            card.addSocial(socialUrl, platform);
          }
        });
      }
      
      // Add other URLs and handle WhatsApp links
      if (userInfo.links && userInfo.links.other) {
        userInfo.links.other.forEach((link) => {
          if (link.url) {
            // Check if it's a WhatsApp link
            if (link.url.includes('wa.me/') || link.url.includes('whatsapp.com')) {
              // Extract phone number from WhatsApp URL - get everything after wa.me/
              const phoneMatch = link.url.match(/wa\.me\/(.+)/);
              if (phoneMatch) {
                const phoneNumber = phoneMatch[1];
                card.addPhoneNumber(phoneNumber, "WORK;MSG");
              }
            } else {
              card.addURL(link.url, "WORK");
            }
          }
        });
      }
      
      card.setFilename(userInfo.general.full_names);
    } else {
      card.setFormat("vcard");
      card.addName(lastname, firstname, additional, prefix, suffix);
      card.addRole(userInfo.general.job_title);
      card.addJobtitle(userInfo.general.job_title);
      card.addCompany(userInfo.general.company);
      
      // Add website URL properly
      if (userInfo.general.website) {
        card.addURL(userInfo.general.website, "WORK");
      }
      
      card.addPhotoURL(userInfo.profile);
      card.addPhoneNumber(userInfo.general.phone, "PREF;WORK");
      card.addEmail(userInfo.general.email);
      
      // Add address as full text in street field
      if (userInfo.general.address) {
        const cleanedAddress = cleanAddressField(userInfo.general.address);
        card.addAddress('', '', cleanedAddress, '', '', '', '');
      }
      
      // Add social links if available (just URL, no platform/handle)
      if (userInfo.links && userInfo.links.social) {
        userInfo.links.social.forEach((socialUrl) => {
          if (socialUrl) {
            // Detect social platform type from URL
            let platform = "WORK";
            if (socialUrl.includes('linkedin.com')) {
              platform = "LinkedIn";
            } else if (socialUrl.includes('twitter.com') || socialUrl.includes('x.com')) {
              platform = "Twitter";
            } else if (socialUrl.includes('facebook.com')) {
              platform = "Facebook";
            } else if (socialUrl.includes('instagram.com')) {
              platform = "Instagram";
            } else if (socialUrl.includes('github.com')) {
              platform = "GitHub";
            } else if (socialUrl.includes('youtube.com')) {
              platform = "YouTube";
            } else if (socialUrl.includes('tiktok.com')) {
              platform = "TikTok";
            }
            card.addSocial(socialUrl, platform);
          }
        });
      }
      
      // Add other URLs
      if (userInfo.links && userInfo.links.other) {
        userInfo.links.other.forEach((link) => {
          if (link.url) {
            card.addURL(link.url, "WORK");
          }
        });
      }
      
      card.setFilename(userInfo.general.full_names);

      if (userInfo.other) {
        userInfo.other.forEach((other) => {
          switch (other.type) {
            case "email":
              card.addEmail(other.value);
              break;
            case "phone":
              card.addPhoneNumber(other.value, other.title);
              break;
            case "address":
              // Clean the entire address and put it all in the street field to avoid line breaks
              const cleanedAddress = cleanAddressField(other.label);
              card.addAddress('', '', cleanedAddress, '', '', '', '');
              break;
            case "link":
              // Check if it's a WhatsApp link
              if (other.url && (other.url.includes('wa.me/') || other.url.includes('whatsapp.com'))) {
                // Extract phone number from WhatsApp URL - get everything after wa.me/
                const phoneMatch = other.url.match(/wa\.me\/(.+)/);
                if (phoneMatch) {
                  const phoneNumber = phoneMatch[1];
                  card.addPhoneNumber(phoneNumber, "WORK");
                }
              } else if (other.value) {
                card.addURL(other.value, "WORK");
              }
              break;
            default:
              break;
          }
        });
      }
    }
  
    fileDownload(
      card.toString(),
      `${userInfo.general.full_names}.vcf`,
      isAndroid() ? "text/x-vcard" : "text/vcard"
    );
    setInstallOpened(true);
  };

  // Users often miss the final "Create New Contact" step after the vCard
  // opens, so on non-Android devices we default to showing an explanatory
  // sheet before downloading. Android has its own post-download instructions.
  const handleSaveContact = () => {
    if (!isAndroid()) {
      saveEvent({ action_type: "open", target: "save_instructions" });
      setConfirmSaveOpened(true);
    } else {
      save(data);
    }
  };

  const getUrl = () => {
    const cannonical = document.querySelector("link[rel=cannonical]");
    const url = cannonical ? cannonical.href : document.location.href;
    return url;
  };
  const share = async () => {
    saveEvent({ action_type: "share", target: "share_btn" });
    const shareDetails = {
      url: `${getUrl()}`,
      title: "Digital business card",
      text: `Hello there, here is ${data.general.full_names} business card.`,
    };
    if (navigator.share) {
      try {
        await navigator.share(shareDetails).then(() => {
          setInstallOpened(true);
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const saveEvent = async (event) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (process.env.NODE_ENV !== "production") {
      console.log("profile_analytics event (dev only):", {
        ...event,
        card_id: id,
        device_type: deviceType,
        browser: browserName,
        location: timeZone,
        org_id: data?.team?.id || null,
      });
      return;
    }

    const payload = {
      card_id: id,
      action_type: event.action_type,
      target: event.target,
      browser: browserName,
      device_type: deviceType,
      location: timeZone,
      org_id: data?.team?.id || null,
    };

    if (event.action_type === "view_profile" && event.referrer) {
      payload.referrer = event.referrer;
    }

    const { error } = await supabase.from("profile_analytics").insert(payload);
    if (error) {
      console.error(error);
    }
  };

  if (loading)
    return (
      <div className="flex w-screen h-screen">
        <div className="m-auto">
          <SpinnerDotted
            size={50}
            thickness={100}
            speed={100}
            color="#36ad47"
          />
        </div>
      </div>
    );

  if (!data) return <Brand />;

  const toAbsoluteUrl = (url) => {
    if (!url || typeof url !== "string") return url;
    const trimmed = url.trim();
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return "https://" + trimmed;
  };

  const getSocialLabel = (url) => {
    if (!url) return "Social";
    if (url.includes("linkedin.com")) return "LinkedIn";
    if (url.includes("twitter.com") || url.includes("x.com")) return "X";
    if (url.includes("facebook.com")) return "Facebook";
    if (url.includes("instagram.com")) return "Instagram";
    if (url.includes("github.com")) return "GitHub";
    if (url.includes("youtube.com")) return "YouTube";
    if (url.includes("tiktok.com")) return "TikTok";
    if (url.includes("medium.com")) return "Medium";
    return "Other";
  };

  const makeCode = (small) => (
    <QRNormal
      value={getUrl()}
      className="my-qrcode"
      styles={{ svg: { width: small ? `160px` : "320px" } }}
      type="round"
      size={72}
      opacity={100}
      posType="round"
      otherColor="#808080"
      posColor="#000000"
      icon={Icon}
    />
  );

  return (
    <>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <div className="mb-64 p-1 ">
          {team && (
            <BusinessCardProfile
              onEvent={saveEvent}
              {...{
                name: data.general.full_names,
                title: data.general.job_title,
                company: team.brand.name,
                tagline: team.brand.tag,
                biography: team.brand.bio,
                website: team.brand.website,
                address: team.brand.address,
                profileImage: data?.profile,
                wallpaperImage: team.brand.wall,
                logoImage: team.brand.logo,
                accentColor: team.theme.accent,
                backgroundColor: team.theme.background,
                primaryColor: team.theme.primary,
                secondaryColor: team.theme.secondary,
              }}
            />
          )}
          {data.general.full_names && team == null && (
            <div className="relative bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl m-2 shadow-xl max-w-4xl mx-auto overflow-hidden flex flex-col">
              <button
                type="button"
                onClick={share}
                aria-label="Share card"
                className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm text-slate-600 dark:text-slate-300 shadow-sm border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/80 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5 shrink-0"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                  />
                </svg>
              </button>
              <div className="flex flex-col md:flex-row flex-1">
              <div className="w-full md:w-1/3 bg-slate-50 dark:bg-slate-800/50 pt-8 md:pt-8 px-8 pb-8 border-b md:border-b-0 md:border-r border-slate-200 dark:border-slate-800 flex flex-col items-center text-center">
                {data.profile && (
                  <div className="relative mb-6">
                    <img
                      alt="Profile"
                      className="w-32 h-32 rounded-3xl object-cover border-4 border-white dark:border-slate-700 shadow-xl"
                      src={data.profile}
                    />
                    <div className="absolute -bottom-2 -right-2 bg-emerald-600 text-white w-8 h-8 rounded-full flex items-center justify-center border-4 border-slate-50 dark:border-slate-800">
                      <CheckBadgeIcon className="w-4 h-4" />
                    </div>
                  </div>
                )}
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white">{data.general.full_names}</h2>
                <p className="text-emerald-600 dark:text-emerald-400 font-semibold text-sm">{data.general.job_title || "—"}</p>
                <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">{data.general.company || "—"}</p>

                {data.links?.social && data.links.social.length > 0 && (
                  <div className="mt-6 flex flex-wrap justify-center gap-2">
                    {data.links.social.map((url) => (
                      <button
                        key={url}
                        type="button"
                        onClick={() =>
                          saveEvent({
                            action_type: "click",
                            target: `social_${getSocialLabel(url).toLowerCase()}`,
                          })
                        }
                        className="!w-10 !h-10"
                      >
                        <SocialIcon
                          url={toAbsoluteUrl(url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="!w-10 !h-10"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="flex-1 p-8 pt-12 md:pt-16 space-y-6">
                {data.general?.bio && (
                  <div>
                    <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-2">About</h4>
                    <p className="text-slate-600 dark:text-slate-300 leading-relaxed">
                      {data.general.bio}
                    </p>
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-3">Contact Information</h4>
                    <div className="space-y-3">
                      {data.general?.email && (
                      <a
                        href={`mailto:${data.general.email}`}
                        onClick={() =>
                          saveEvent({
                            action_type: "click",
                            target: "contact_email",
                          })
                        }
                        className="flex items-center space-x-3 text-sm font-medium text-slate-700 dark:text-slate-300 hover:text-emerald-600 dark:hover:text-emerald-400"
                      >
                          <EnvelopeIcon className="w-5 h-5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                          <span className="truncate">{data.general.email}</span>
                        </a>
                      )}
                      {data.general?.phone && (
                      <a
                        href={`tel:${data.general.phone}`}
                        onClick={() =>
                          saveEvent({
                            action_type: "click",
                            target: "contact_phone",
                          })
                        }
                        className="flex items-center space-x-3 text-sm font-medium text-slate-700 dark:text-slate-300 hover:text-emerald-600 dark:hover:text-emerald-400"
                      >
                          <PhoneIcon className="w-5 h-5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                          <span>{data.general.phone}</span>
                        </a>
                      )}
                      {data.general?.website && (
                      <a
                        href={toAbsoluteUrl(data.general.website)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                          saveEvent({
                            action_type: "click",
                            target: "contact_website",
                          })
                        }
                        className="flex items-center space-x-3 text-sm font-medium text-slate-700 dark:text-slate-300 hover:text-emerald-600 dark:hover:text-emerald-400 truncate"
                      >
                          <GlobeAltIcon className="w-5 h-5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                          <span className="truncate">{data.general.website.replace(/^https?:\/\//i, "")}</span>
                        </a>
                      )}
                      {!data.general?.email && !data.general?.phone && !data.general?.website && (
                        <span className="text-sm text-slate-500 dark:text-slate-400">—</span>
                      )}
                    </div>
                  </div>
                  {data.links?.other && data.links.other.length > 0 && (
                    <div>
                      <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-2">Links</h4>
                      <div className="flex flex-col gap-2">
                        {data.links.other.map((link, i) => (
                          <a
                            key={i}
                            href={toAbsoluteUrl(link.url)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                              saveEvent({
                                action_type: "click",
                                target: `link_${(link.title || "other").toLowerCase().replace(/\s+/g, "_")}`,
                              })
                            }
                            className="text-emerald-600 dark:text-emerald-400 font-medium hover:underline text-sm"
                          >
                            {link.title}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {data.other && data.other.length > 0 && (
                  <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
                    <h4 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-2">More</h4>
                    <Other
                      other={data.other}
                      onEvent={saveEvent}
                    />
                  </div>
                )}
              </div>
              </div>

              <Sheet
                isOpen={codeExpanded}
                onClose={() => setCodeExpanded(false)}
                detent="content-height"
              >
                <Sheet.Container>
                  <Sheet.Header>
                          <div className="flex items-center justify-between w-full px-4 py-3">
                            <h2 className="text-lg font-bold text-slate-900 dark:text-white">
                              Let's make it happen
                            </h2>
                            <button
                              type="button"
                              className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500"
                              onClick={() => setCodeExpanded(false)}
                              aria-label="Close"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                  </Sheet.Header>
                  <Sheet.Content className="flex flex-col px-5 pb-4">
                          <div className="overflow-y-auto">
                            <p className="text-slate-600 dark:text-slate-400 text-sm mb-5 px-1">
                              Be proactive and connect with <span className="font-bold text-slate-900 dark:text-white">{data?.general?.full_names || "them"}</span> immediately.
                            </p>
                            <div className="space-y-5">
                            {(data?.general?.phone || data?.general?.email) && (
                              <section>
                                <div className="flex gap-3">
                                  {data?.general?.phone && (
                                    <a
                                      href={`sms:${data.general.phone}`}
                                      onClick={() => saveEvent({ action_type: "click", target: "quick_connect_sms" })}
                                      className="flex-1 min-w-0 flex flex-col items-center justify-center gap-3 py-5 px-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 border border-slate-100 dark:border-slate-700/50 text-slate-800 dark:text-slate-200 font-medium text-sm transition-colors"
                                    >
                                      <ChatBubbleLeftRightIcon className="w-10 h-10 text-emerald-500 dark:text-emerald-400 shrink-0" />
                                      <span>Send a text</span>
                                    </a>
                                  )}
                                  {data?.general?.email && (
                                    <a
                                      href={`mailto:${data.general.email}`}
                                      onClick={() => saveEvent({ action_type: "click", target: "quick_connect_email" })}
                                      className="flex-1 min-w-0 flex flex-col items-center justify-center gap-3 py-5 px-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 border border-slate-100 dark:border-slate-700/50 text-slate-800 dark:text-slate-200 font-medium text-sm transition-colors"
                                    >
                                      <EnvelopeIcon className="w-10 h-10 text-emerald-500 dark:text-emerald-400 shrink-0" />
                                      <span>Send an email</span>
                                    </a>
                                  )}
                                </div>
                              </section>
                            )}
                            {!data?.general?.phone && !data?.general?.email && (
                              <p className="text-sm text-slate-500 dark:text-slate-400 py-2">No contact options available.</p>
                            )}
                            </div>
                            {/* <div className="flex flex-col items-center justify-center pt-6 pb-4">
                              <div className="w-full rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700/50 flex flex-col items-center gap-2 py-6 px-4">
                                {makeCode(true)}
                                <p className="text-xs text-slate-500 dark:text-slate-400 text-center">
                                  Scan code for {data?.general?.full_names ? <span className="font-bold text-slate-900 dark:text-white">{data.general.full_names}'s</span> : "this"} business card
                                </p>
                              </div>
                            </div> */}
                          </div>
                          <footer className="shrink-0 pt-6 pb-2 border-t border-none space-y-4">
                            <div className="flex gap-2 w-full">
                              <button
                                type="button"
                                className="shrink-0 py-3 px-4 rounded-xl bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-medium text-sm shadow-sm border border-slate-200 dark:border-slate-700 inline-flex items-center justify-center gap-2 hover:bg-slate-50 dark:hover:bg-slate-700/80 transition-colors"
                                onClick={() => { saveEvent({ action_type: "share", target: "quick_connect_share" }); share(); setCodeExpanded(false); }}
                                aria-label="Share card"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth={1.5}
                                  stroke="currentColor"
                                  className="w-5 h-5 shrink-0"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                                  />
                                </svg>
                                <span>Share</span>
                              </button>
                              <a
                                href="https://app.nami.africa"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => saveEvent({ action_type: "click", target: "quick_connect_get_card" })}
                                className="flex-1 min-w-0 flex items-center justify-center py-3 px-4 rounded-xl bg-emerald-600 text-white font-semibold text-sm shadow-md hover:opacity-90 transition-opacity gap-2"
                              >
                                Get yours <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 shrink-0">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                </svg>
                              </a>
                            </div>
                            <div className="flex justify-center items-center gap-2">
                              <img src={Icon} alt="Nami" className="h-4 w-4 object-contain" />
                              <span className="text-xs text-slate-500 dark:text-slate-400">
                                Runs on{" "}
                                <a href="https://nami.africa" target="_blank" rel="noopener noreferrer" className="font-semibold text-slate-700 dark:text-slate-300 hover:underline">
                                  Nami
                                </a>
                              </span>
                            </div>
                          </footer>
                        </Sheet.Content>
                      </Sheet.Container>
                      <Sheet.Backdrop onTap={() => setCodeExpanded(false)} />
                    </Sheet>
                    <Sheet
                      isOpen={installOpened}
                      onClose={() => setInstallOpened(false)}
                      disableDrag={true}
                    >
                      <Sheet.Container>
                        <Sheet.Header>
                          <div className="flex justify-end p-2">
                            <button
                              className="p-2"
                              onClick={() => setInstallOpened(false)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="gray"
                                class="w-6 h-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        </Sheet.Header>
                        <Sheet.Content>
                          {isAndroid() ? (
                            <AndroidInstructions onClose={() => setInstallOpened(false)} />
                          ) : (
                            <Brand />
                          )}
                        </Sheet.Content>
                      </Sheet.Container>

                      <Sheet.Backdrop />
                    </Sheet>
            </div>
          )}
        </div>
        <div className="grow flex" />
        <footer
          style={{
            "--accent-color": team ? team.theme.accent : "slate-700",
            "--background-color": "white",
            "--primary-color": team ? team.theme.primary : "slate-900",
            "--secondary-color": team ? team.theme.secondary : "slate-800",
            backgroundColor: "var(--background-color)",
          }}
          className={`fixed bottom-0 left-0 right-0 flex md:items-center md:justify-between mb-0 bg-white ${
            team ? `border-[${team.theme.accent}]` : "border-slate-300"
          } border-t transition-transform duration-300 ease-in-out rounded-t-xl`}
        >
          <div className="w-full flex flex-col pt-6">
            {data.general.full_names && (
              <div className="flex justify-center w-full max-w-md mx-auto pr-4 pl-4">
                <div className="flex w-full max-w-sm gap-2">
                  <button
                    type="button"
                    className="shrink-0 py-3 px-4 rounded-xl bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-medium text-sm shadow-sm border border-slate-200 dark:border-slate-700 inline-flex items-center justify-center gap-2 hover:bg-slate-50 dark:hover:bg-slate-700/80 transition-colors"
                    onClick={() => {
                      saveEvent({ action_type: "open", target: "quick_connect" });
                      setCodeExpanded(true);
                    }}
                    aria-label="Instant connect"
                  >
                    <BoltIcon className="w-5 h-5 shrink-0" />
                    <span>Instant connect</span>
                  </button>
                  <button
                    type="button"
                    className="flex-1 min-w-0 py-3 px-4 rounded-xl bg-emerald-600 text-white font-semibold text-sm shadow-sm border-0 inline-flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
                    onClick={handleSaveContact}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-5 h-5 shrink-0"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                      />
                    </svg>
                    <span>Save contact</span>
                  </button>
                </div>
              </div>
            )}
            <div className="w-full p-4 flex justify-center items-center gap-2">
              <img src={Icon} alt="Nami" className="h-4 w-4 object-contain" />
              <span className="text-xs text-gray-500 sm:text-center dark:text-gray-400 ">
                Runs on{" "}
                <span className="font-semibold text-sm">
                  <a
                    href="https://nami.africa"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    Nami
                  </a>
                </span>
              </span>
            </div>
          </div>
        </footer>
      </div>
      <Sheet
        isOpen={confirmSaveOpened}
        onClose={() => setConfirmSaveOpened(false)}
        detent="content-height"
      >
        <Sheet.Container>
          <Sheet.Header>
            <div className="flex justify-end p-2">
              <button
                className="p-2"
                onClick={() => setConfirmSaveOpened(false)}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="gray"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </Sheet.Header>
          <Sheet.Content>
            <SaveContactInstructions
              onConfirm={() => {
                setConfirmSaveOpened(false);
                save(data);
              }}
            />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={() => setConfirmSaveOpened(false)} />
      </Sheet>
      <Transition appear show={showCard} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10 "
          onClose={() => setShowCard(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto rotate-90">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl text-left align-middle shadow-xl transition-all">
                  <ReactCardFlip
                    isFlipped={showBack}
                    flipDirection="vertical"
                    flipSpeedBackToFront={0.6}
                    flipSpeedFrontToBack={0.6}
                  >
                    <div
                      className="p-0 justify-center items-center max-w-screen-sm"
                      onClick={() => setShowBack(true)}
                    >
                      {data.business && data.business.card_front && (
                        <Image src={data.business.card_front} />
                      )}
                    </div>
                    <div
                      className="justify-center items-center transition-all transition ease-in-out "
                      onClick={() => setShowBack(false)}
                    >
                      {data.business && data.business.card_back && (
                        <Image src={data.business.card_back} />
                      )}
                    </div>
                  </ReactCardFlip>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default Card;
